"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* *
 *  H5调起APP分享
 *
 */
var setImage = [{
  pattern: {
    "IOS|FINO": ["gte", "1.0.9"],
    "ANDROID|FINO": ["gte", "1.1.0"]
  },
  handler: function handler(option) {
    return this.invoke(106, {
      type: "image", //分享类型，有：text, image, url
      url: option.shareUrl, // 当type = image 表示 图片地址; 当type = url 表示分享链接
      title: option.shareTitle, // 标题 当type != text
      description: option.shareDescription, // 文字说明（分享摘要） 当type != text
      mediaTagName: option.shareMediaTagName //当type != text 微信MP统计用标签(选填)
    });
  }
}, {
  pattern: {
    "IOS|FINO": ["gte", "1.0.0"],
    "ANDROID|FINO": ["gte", "1.0.0"]
  },
  handler: function handler(option) {
    return this.invoke(106, {
      type: "image", //分享类型，有：text, image, url
      url: option.shareUrl, // 当type = image 表示 图片地址; 当type = url 表示分享链接
      title: option.shareTitle, // 标题 当type != text
      description: option.shareDescription, // 文字说明（分享摘要） 当type != text
      mediaTagName: option.shareMediaTagName //当type != text 微信MP统计用标签(选填)
    });
  }
}];

var setUrl = [{
  pattern: {
    "IOS|MZMall": ["gte", "1.0.9"],
    "ANDROID|MZMall": ["gte", "1.1.0"]
  },
  handler: function handler(option) {
    return this.invoke(106, {
      type: "url", //分享类型，有：text, image, url
      url: option.shareUrl, // 当type = image 表示 图片地址; 当type = url 表示分享链接
      title: option.shareTitle, // 标题 当type != text
      description: option.shareDescription, // 文字说明（分享摘要） 当type != text
      mediaTagName: option.shareMediaTagName, //当type != text 微信MP统计用标签(选填)
      thumbData: option.shareThumbData, //缩略图（base64） 当type = url,
      thumbUrl: option.shareThumbUrl //缩略图地址  当type = url
    });
  }
}, {
  pattern: {
    "IOS|MZFilm": ["gte", "1.0.0"],
    "ANDROID|MZFilm": ["gte", "1.0.0"]
  },
  handler: function handler(option) {
    return this.invoke(106, {
      type: "url", //分享类型，有：text, image, url
      url: option.shareUrl, // 当type = image 表示 图片地址; 当type = url 表示分享链接
      title: option.shareTitle, // 标题 当type != text
      description: option.shareDescription, // 文字说明（分享摘要） 当type != text
      mediaTagName: option.shareMediaTagName, //当type != text 微信MP统计用标签(选填)
      thumbData: option.shareThumbData, //缩略图（base64） 当type = url,
      thumbUrl: option.shareThumbUrl //缩略图地址  当type = url
    });
  }
}];

var setText = [{
  pattern: {
    "IOS|MZMall": ["gte", "1.0.9"],
    "ANDROID|MZMall": ["gte", "1.1.0"]
  },
  handler: function handler(option) {
    return this.invoke(106, {
      type: "text", //分享类型，有：text, image, url
      text: option.shareText //当type = text 表示分享文本
    });
  }
}, {
  pattern: {
    "IOS|MZFilm": ["gte", "1.0.0"],
    "ANDROID|MZFilm": ["gte", "1.0.0"]
  },
  handler: function handler(option) {
    return this.invoke(106, {
      type: "text", //分享类型，有：text, image, url
      text: option.shareText //当type = text 表示分享文本
    });
  }
}];

var image = [{
  pattern: {
    "IOS|MZMall": ["gte", "1.0.9"],
    "ANDROID|MZMall": ["gte", "1.1.0"]
  },
  handler: function handler(option) {
    return this.invoke(107, {
      type: "image", //分享类型，有：text, image, url
      url: option.shareUrl, // 当type = image 表示 图片地址; 当type = url 表示分享链接
      title: option.shareTitle, // 标题 当type != text
      description: option.shareDescription, // 文字说明（分享摘要） 当type != text
      mediaTagName: option.shareMediaTagName //当type != text 微信MP统计用标签(选填)
    });
  }
}, {
  pattern: {
    "IOS|MZFilm": ["gte", "1.0.0"],
    "ANDROID|MZFilm": ["gte", "1.0.0"]
  },
  handler: function handler(option) {
    return this.invoke(107, {
      type: "image", //分享类型，有：text, image, url
      url: option.shareUrl, // 当type = image 表示 图片地址; 当type = url 表示分享链接
      title: option.shareTitle, // 标题 当type != text
      description: option.shareDescription, // 文字说明（分享摘要） 当type != text
      mediaTagName: option.shareMediaTagName //当type != text 微信MP统计用标签(选填)
    });
  }
}];

var url = [{
  pattern: {
    "IOS|MZMall": ["gte", "1.0.9"],
    "ANDROID|MZMall": ["gte", "1.1.0"]
  },
  handler: function handler(option) {
    return this.invoke(107, {
      type: "url", //分享类型，有：text, image, url
      url: option.shareUrl, // 当type = image 表示 图片地址; 当type = url 表示分享链接
      title: option.shareTitle, // 标题 当type != text
      description: option.shareDescription, // 文字说明（分享摘要） 当type != text
      mediaTagName: option.shareMediaTagName, //当type != text 微信MP统计用标签(选填)
      thumbData: option.shareThumbData, //缩略图（base64） 当type = url,
      thumbUrl: option.shareThumbUrl //缩略图地址  当type = url
    });
  }
}, {
  pattern: {
    "IOS|MZFilm": ["gte", "1.0.0"],
    "ANDROID|MZFilm": ["gte", "1.0.0"]
  },
  handler: function handler(option) {
    return this.invoke(107, {
      type: "url", //分享类型，有：text, image, url
      url: option.shareUrl, // 当type = image 表示 图片地址; 当type = url 表示分享链接
      title: option.shareTitle, // 标题 当type != text
      description: option.shareDescription, // 文字说明（分享摘要） 当type != text
      mediaTagName: option.shareMediaTagName, //当type != text 微信MP统计用标签(选填)
      thumbData: option.shareThumbData, //缩略图（base64） 当type = url,
      thumbUrl: option.shareThumbUrl //缩略图地址  当type = url
    });
  }
}];

var text = [{
  pattern: {
    "IOS|MZMall": ["gte", "1.0.9"],
    "ANDROID|MZMall": ["gte", "1.1.0"]
  },
  handler: function handler(option) {
    return this.invoke(107, {
      type: "text", //分享类型，有：text, image, url
      text: option.shareText //当type = text 表示分享文本
    });
  }
}, {
  pattern: {
    "IOS|MZFilm": ["gte", "1.0.0"],
    "ANDROID|MZFilm": ["gte", "1.0.0"]
  },
  handler: function handler(option) {
    return this.invoke(107, {
      type: "text", //分享类型，有：text, image, url
      text: option.shareText //当type = text 表示分享文本
    });
  }
}];

exports.default = {
  image: image,
  text: text,
  url: url,
  setImage: setImage,
  setText: setText,
  setUrl: setUrl
};